/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyConfig } from '../models/CompanyConfig';
import type { PatchedCompanyConfig } from '../models/PatchedCompanyConfig';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompanyConfigEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns CompanyConfig
   * @throws ApiError
   */
  public companyConfigRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this company.
     */
    id: string,
  }): CancelablePromise<CompanyConfig> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/company-config/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns CompanyConfig
   * @throws ApiError
   */
  public companyConfigUpdate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this company.
     */
    id: string,
    requestBody: CompanyConfig,
  }): CancelablePromise<CompanyConfig> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/company-config/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns CompanyConfig
   * @throws ApiError
   */
  public companyConfigPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this company.
     */
    id: string,
    requestBody?: PatchedCompanyConfig,
  }): CancelablePromise<CompanyConfig> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/company-config/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
